<div class="row">
  <div class="col-12" style="margin-left:2%">
    <p class="devliveryPartHeader">
      Configuration for Supplier To Supplier Delivered Parts
    </p>
  </div>
 
  <div class="col-12">
    <mat-radio-group [(ngModel)]="configurationType" (change)="radioChange($event)">
      <mat-radio-button value="MULTIPLE">Predefined</mat-radio-button>
      <mat-radio-button value="SINGLE">Custom</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="col-12">
    <ng-container *ngIf="configurationType != 'MULTIPLE'">
      <form>
        <div class="row">
          <div class="col-12">

          <mat-form-field>
            <input matInput id="noubapattern" [value]="customValue" placeholder="Nouba Pattern" aria-label="Nouba Pattern" [matAutocomplete]="auto" (keyup)="onNoubaCodeValidation($event.target.value)">
            <mat-autocomplete #auto="matAutocomplete" (onSelectionChange)="myChangeFunc($event)">
              <mat-option *ngFor="let list of nobuaFilteredList" [value]="list.itemName" (onSelectionChange)="onPatternSelect(list.itemName)">          
                <span>{{ list.itemName }}</span>           
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
            
          <br />
          <span class='mat-error' *ngIf='isErrorFound'> Enter valid Nouba Code Pattern Ex. T**</span>

          </div>
          </div>

      </form>
    </ng-container>

    <ng-container *ngIf="configurationType == 'MULTIPLE'">
      <!-- <angular2-multiselect [data]="nobuaList" [(ngModel)]="selectedItems"
        [settings]="nobuaListDropDownSettings" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)"
        (onFilterSelectAll)="onFilterSelectAll($event)">
      </angular2-multiselect> -->
      <ng-multiselect-dropdown [settings]="nobuaListDropDownSettings"  [data]="nobuaList" [(ngModel)]="selectedItems" 
        (onSelect)="onItemSelect($event)" 
        (onDeSelect)="OnItemDeSelect($event)"
        (onSelectAll)="onSelectAll($event)"
        (onDeSelectAll)="onDeSelectAll($event)">
      </ng-multiselect-dropdown>
    </ng-container>
  </div>

  <div class="col-12" style="padding-top: 12px">
    <mat-spinner diameter="25" mode="determinate" *ngIf="isDataSubmitLoading"></mat-spinner>

    <ng-container *ngIf="!isDataSubmitLoading">
      <ng-container *ngIf="configurationType != 'MULTIPLE'">
        <button mat-button style="background-color: rgb(211, 209, 209);margin-left:2%" cdkFocusInitial (click)="onSubmit()" [disabled]="
            isDataSubmitLoading || !isNoubaHasRightPattern
          ">
          Ok
        </button>
      </ng-container>

      <ng-container *ngIf="configurationType == 'MULTIPLE'">
        <button mat-button style="background-color: rgb(211, 209, 209);margin-left:2%" cdkFocusInitial (click)="onSubmit()" [disabled]="
            isDataSubmitLoading || selectedItems.length == 0
          ">
          Ok
        </button>
      </ng-container>

      <button mat-button style="background-color: rgb(240, 237, 237);margin-left:5%" (click)="onNoClick()"
        [disabled]="isDataSubmitLoading">
        Close
      </button>
    </ng-container>
  </div>
</div>